import React from 'react'

export const EnterpriseBusinessIcon = ({
  selected
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="38" viewBox="0 0 34 38" fill="none">
  <rect x="1.5" y="1.5" width="13" height="35" rx="1" fill="none" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="9.5" y="6.5" width="13" height="30" rx="1" fill="none" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="19.5" y="10.5" width="13" height="26" rx="1" fill="none" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="12.5" y="14.5" width="4" height="4" rx="1" transform="rotate(-90 12.5 14.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="4.5" y="8.5" width="4" height="4" rx="1" transform="rotate(-90 4.5 8.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="12.5" y="21.5" width="4" height="4" rx="1" transform="rotate(-90 12.5 21.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="4.5" y="15.5" width="4" height="4" rx="1" transform="rotate(-90 4.5 15.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="24.5" y="20.5" width="4" height="4" rx="1" transform="rotate(-90 24.5 20.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="12.5" y="28.5" width="4" height="4" rx="1" transform="rotate(-90 12.5 28.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="4.5" y="22.5" width="4" height="4" rx="1" transform="rotate(-90 4.5 22.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="24.5" y="36.5" width="11" height="4" rx="1" transform="rotate(-90 24.5 36.5)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
</svg>
  )
}
